import { useEffect, useState } from "react";
import { validEmailRegex } from "../../../constants/common";
import { useQueryContext } from "../../../contexts/query";
import { useLoginMutation } from "../../../services/react-query/auth";

const INPUT_TYPES = {
    EMAIL: 'email',
    PASSWORD: "password"
}


const useLogin = () => {

    const inputInitial = {
        email: '',
        password: '',
    }
    const [inputData, setInputData] = useState(inputInitial)

    const { mutate: login } = useLoginMutation()

    const statusInitial = {
        email: null,
        password: null,
    }
    const [inputStatus, setInputStatus] = useState(statusInitial)

    const [validAction, setValidAction] = useState(false)


    /**
     * effects - timer and action validation
     */

    useEffect(() => {
        const valid =
            (inputStatus.email && inputStatus.password)
        setValidAction(valid)
    }, [inputStatus])



    const onInputValueChange = (v, type) => {

        switch (type) {
            case INPUT_TYPES.EMAIL:
                validateUsername(v)
                setInputData(state => ({ ...state, email: v }))
                break
            case INPUT_TYPES.PASSWORD:
                validatePassword(v)
                setInputData(state => ({ ...state, password: v }))
                break
            default:
                break
        }
    }

    /**
     * validations
     */
    const validateUsername = (val) => {
        if (val && val.length > 0) {
            if (isNaN(val)) {
                // gmail
                const valid = validEmailRegex.test(val)
                setInputStatus(state => ({ ...state, email: valid }))
            }
        }
        if (val.length === 0) {
            setInputStatus(state => ({ ...state, email: null }))
        }
    }


    const validatePassword = (val) => {
        const valid = val.length >= 8
        setInputStatus(state => ({ ...state, password: valid }))
    }


    /**
     * operations
     */

    const { setToast } = useQueryContext()
    const onSubmitClicked = () => {
        if (validAction) {
            login({ data: inputData })
        } else {
            setToast({
                isError: true, show: true,
                message: 'fill-input-errors'
            })
        }
    }

    return {
        inputData,
        inputStatus,
        loading: false,
        validAction,
        onInputValueChange,
        onSubmitClicked,
    }
}

export default useLogin
export {
    INPUT_TYPES
}
